<template lang="pug">
div
  //- pre {{initBlock}}
  v-date-picker(:columns="2", :value="initBlock.value.date" @input="updateValue" :input-debounce="100")
    template(v-slot='{ inputValue, togglePopover }')
      b-field(:label="initBlock.config.label" label-position="on-border")
        input.input(:value='inputValue' @click="togglePopover({ inputDebounce: 100, placement: 'auto-start' })")
        b-button(type="is-flat" icon-left="delete-outline" @click="updateValue(null)")
</template>

<script>

export default {
  components: {

  },
  props: {
    parentKey: String,
    value: Object,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            date: null
          },
          config: null
        }
      }
    }
  },
  data() {
    return {
    };
  },
  methods: {
    updateValue(e) {
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          date: e
        }
      });
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>

</style>